import {
  GET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEATMAP_DATA,
  GET_DATAGUARD_HEATMAP_DATA,
  GET_DATAGUARD_ROLES_DATA,
  SET_DATAGUARD_ROLES_DATA,
  GET_USER_ROLE_URL,
  GET_BEHAVIOR_MODEL_URL,
  SET_DATAGUARD_BEHAVIOR_DATA,
  GET_DATAGUARD_BEHAVIOR_DATA,
  LOCATION_SUMMARY_API,
  GET_LOCATION_SUMMARY,
  SET_LOCATION_SUMMARY,
  GET_KEY_DOC_OWNER_DATA,
  SET_KEY_DOC_OWNER_DATA,
  KEY_DOC_OWNER_API,
  notificationToggle,
  DATA_GUARD_NOTIFICATION_TOGGLE,
  SET_NOTIFICATION_UPDATE_STATUS,
  revokePublicAccessAPI,
  PUBLIC_ACCESS_REVOKE_USER,
  SET_REVOKE_ACCESS_UPDATE_STATUS,
  SAVE_DATA_GUARD_COMMENT,
  SET_DATA_GUARD_ALERT_COMMENT,
  CREATE_DATA_GUARD_JIRA_INCIDENT,
  DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL,
  DATA_GUARD_REPORT_INCIDENT_FAILED,
  SET_DATA_GUARD_REPORT_INCIDENT_DETAILS,
  OPEN_DATA_GUARD_SNACKBAR,
  reportToJiraDataGuard,
  UPDATE_ALERTS_STATUS_URL,
  UPDATE_ALERT_STATUS_REQUEST_DATAGUARD,
  UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
  UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
  ALERT_ACTION_REQUEST_DATAGUARD,
  ALERT_ACTION_SUCCESS_DATAGUARD,
  ALERT_ACTION_FAILED_DATAGUARD,
  alertActionAPI,
} from "../Utility/DataguardConstant";
import {
  getCubejsApi,
} from "../../../components/common/Dashboard/cubejs-util";
import { getAxiosHeaders, getService } from "../../../library/RestAPI";
import { SAVE_ALERT_COMMENT_URL } from "../../../redux/constants/constants";
import { FETCH_POPUP_DATA, SET_POPUP_LOADER } from "../../DataGuard/Popup/ActionTypes";
import { FETCH_DETAIL_PAGE_DATA_REQUEST } from "../DetailPages/redux/detailPageActions";

const { takeEvery, put, select, call } = require("redux-saga/effects");

function* fetchRolesData(action) {
  try {
    yield put({ type: 'SET_ROLES_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${GET_USER_ROLE_URL}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_DATAGUARD_ROLES_DATA, payload: response.data });
    }
    yield put({ type: 'SET_ROLES_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_ROLES_LOADER', payload: false });
    console.error("Error fetching roles data:", error);
    // Handle error appropriately
  }
}

function* fetchBehaviorData(action) {
  try {
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${GET_BEHAVIOR_MODEL_URL}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_DATAGUARD_BEHAVIOR_DATA, payload: response.data });
    }
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: false });
    console.error("Error fetching behavior data:", error);
    // Handle error appropriately
  }
}

function* fetchHeaderData(action) {
  const { fromTimeStamp, toTimeStamp } = action.payload;
  const cubejs = getCubejsApi();
  const suspiciousHeaderData = {
    measures: [
      "DataguardSuspiciousUsers.totalUsers",
      "DataguardSuspiciousUsers.suspiciousUser",
    ],
    filters: [
      {
        or: [
          {
            member: "DataguardSuspiciousUsers.eventTime",
            operator: "notSet"
          },
          {
            and: [
              {
                member: "DataguardSuspiciousUsers.eventTime",
                operator: "gte",
                values: [`${fromTimeStamp}`]
              },
              {
                member: "DataguardSuspiciousUsers.eventTime",
                operator: "lte",
                values: [`${toTimeStamp}`]
              }
            ]
          }
        ]
      }
    ],
  };

  const publicAccessData = {
    measures: [
      "DataguardPublicAccess.totalCount",
      "DataguardPublicAccess.publicCount",
    ],
  };

  try {
    yield put({ type: 'SET_HEADER_LOADER', payload: true });
    const suspiciousData = yield cubejs.load(suspiciousHeaderData);
    const publicData = yield cubejs.load(publicAccessData);

    const suspicious = suspiciousData.rawData();
    const publicAccessRaw = publicData.rawData();

    const dataguardData = {
      suspicious: {
        totalCount: parseInt(
          suspicious[0]["DataguardSuspiciousUsers.totalUsers"]
        ),
        alertCount: parseInt(
          suspicious[0]["DataguardSuspiciousUsers.suspiciousUser"]
        ),
      },
      publicAccess: {
        totalCount: parseInt(
          publicAccessRaw[0]["DataguardPublicAccess.totalCount"]
        ),
        alertCount: parseInt(
          publicAccessRaw[0]["DataguardPublicAccess.publicCount"]
        ),
      },
    };

    yield put({ type: SET_DATAGUARD_HEADER_DATA, payload: dataguardData });
    yield put({ type: 'SET_HEADER_LOADER', payload: false });
  } catch (err) {
    yield put({ type: 'SET_HEADER_LOADER', payload: false });
    console.log(err);
  }
}

function* fetchHeatmapData(action) {
  const cubejs = getCubejsApi();

  const heatmapQuery = {
    dimensions: [
      "DataguardPublicHeatmap.username",
      "DataguardPublicHeatmap.totalPublicResources"
    ],
    order: {
      "DataguardPublicHeatmap.totalPublicResources": "desc"
    },
    limit: action.payload?.limit || 50,
  };
  const totalAssetsQuery = {
    "measures": ["DataguardTotalAssets.totalAssets"]
  };

  try {
    yield put({ type: 'SET_HEATMAP_LOADER', payload: true });
    const result = yield cubejs.load(heatmapQuery);
    const resultTotal = yield cubejs.load(totalAssetsQuery);
    const rawData = result.rawData();
    const totalAssets = resultTotal.rawData();

    // Transform data for heatmap format
    const heatmapData = rawData.map(item => ({
      count: parseInt(item["DataguardPublicHeatmap.totalPublicResources"]),
      username: item["DataguardPublicHeatmap.username"]
    }));
    const totalAssetsCount = totalAssets[0]["DataguardTotalAssets.totalAssets"] || 0;

    yield put({ type: SET_DATAGUARD_HEATMAP_DATA, payload: { heatmapData, totalAssetsCount } });
    yield put({ type: 'SET_HEATMAP_LOADER', payload: false });
  } catch (err) {
    yield put({ type: 'SET_HEATMAP_LOADER', payload: false });
    console.error("Error fetching heatmap data:", err);
  }
}

function* fetchLocationSummary(action) {
  try {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${LOCATION_SUMMARY_API}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_LOCATION_SUMMARY, payload: response.data });
    }
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    console.error("Error fetching location summary data:", error);
    // Handle error appropriately
  }
}

function* fetchKeyDocOwner(action) {
  try {
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${KEY_DOC_OWNER_API}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_KEY_DOC_OWNER_DATA, payload: response.data });
    }
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: false });
    console.error("Error fetching key document owner data:", error);
    // Handle error appropriately
  }
}

function* dataGuardNotificationToggle(action) {
  yield put({ type: 'FETCH_DETAIL_PAGE_DATA_START' });
  const { state, data } = action.payload;
  try {
    let options = {
      method: "PUT",
      url: notificationToggle(state),
      headers: {
        ...getAxiosHeaders(true),
        "Content-Type": "text/plain",
      },
      data: data,
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_NOTIFICATION_UPDATE_STATUS, payload: true });
      yield put({
        type: UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
        payload: `Notification settings updated successfully`,
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      
      // Reload the detail page data after successful notification toggle
      const fromTimeStamp = yield select((state) => state.DataguardReducer.fromTimeStamp);
      const toTimeStamp = yield select((state) => state.DataguardReducer.toTimeStamp);
      const detailPageData = yield select((state) => state.DetailPageReducer);
      
      if (detailPageData && detailPageData.lastPageType && detailPageData.lastApiEndpoint) {
        yield put({
          type: FETCH_DETAIL_PAGE_DATA_REQUEST,
          payload: {
            pageType: detailPageData.lastPageType,
            apiEndpoint: detailPageData.lastApiEndpoint,
            fromTimeStamp,
            toTimeStamp,
            page: detailPageData.page,
            rowsPerPage: detailPageData.rowsPerPage
          }
        });
      } else {
        // If no detail page data is available, just set success state
        yield put({ type: 'FETCH_DETAIL_PAGE_DATA_SUCCESS', payload: { data: detailPageData?.data || null } });
      }
    }
    else {
      yield put({
        type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
        payload: "Failed to update notification settings",
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      yield put({ type: 'FETCH_DETAIL_PAGE_DATA_FAILURE', payload: "Failed to update notification settings" });
    }
  } catch (error) {
    console.error("Error toggling notification:", error);
    yield put({
      type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
      payload: "Error occurred while updating notification settings",
    });
    yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
    yield put({ type: 'FETCH_DETAIL_PAGE_DATA_FAILURE', payload: error.message });
  }
}

function* revokePublicAccessUser(action) {
  try {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });
    const { dataSourceId, userEmailId } = action.payload;
    let allSuccessful = true;
    let revokeCount = 0;

    if (Array.isArray(dataSourceId) && dataSourceId.length > 0) {
      for (const id of dataSourceId) {
        const options = {
          method: "PUT",
          url: revokePublicAccessAPI(id, userEmailId),
          headers: getAxiosHeaders(true),
        };
        const response = yield getService(options);

        if (response?.status === 204) {
          console.log(`Revoked access for DS: ${id}`);
          yield put({ type: SET_REVOKE_ACCESS_UPDATE_STATUS, payload: true });
          revokeCount++;
        } else {
          allSuccessful = false;
        }
      }
      
      if (allSuccessful && revokeCount > 0) {
        yield put({
          type: UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
          payload: `Successfully revoked access for ${revokeCount} data source(s)`,
        });
        yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      } else if (revokeCount > 0) {
        yield put({
          type: UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
          payload: `Partially successful: revoked access for ${revokeCount} out of ${dataSourceId.length} data source(s)`,
        });
        yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      } else {
        yield put({
          type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
          payload: "Failed to revoke access for any data sources",
        });
        yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      }
      
      yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
      console.log("All revokes completed");
    } else {
      console.log("No dataSourceIds to revoke");
      yield put({
        type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
        payload: "No data sources provided for revoke operation",
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    }
  } catch (error) {
    console.error("Error revoking public access:", error);
    yield put({
      type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
      payload: "Error occurred while revoking public access",
    });
    yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
  }
}

function* saveDataGuardAlertComment(action) {
  const { id, comment } = action.payload;
  let commentData = {
    comments: `${comment}`,
  };
  const options = {
    method: "POST",
    url: `${SAVE_ALERT_COMMENT_URL}/${id}/comments`,
    headers: getAxiosHeaders(true),
    data: commentData,
  };
  try {
    const res = yield getService(options);
    if (res && res.status === 201) {
      yield put({ type: SET_DATA_GUARD_ALERT_COMMENT, payload: null });
    }
  } catch (err) {
    console.log(err);
  }
}

function* createDataGuardJiraIncident(action) {
  yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });

  const { alerts, isCompliance } = action.payload;
  const results = [];
  let allSuccessful = true;

  try {
    for (const { alertId, dataSourceID } of alerts) {
      const options = {
        method: "POST",
        url: reportToJiraDataGuard(alertId, dataSourceID),
        headers: getAxiosHeaders(true),
      };

      const res = yield call(getService, options);

      if (res && res.status === 200) {
        results.push(res.data);
      } else {
        allSuccessful = false;
        yield put({ type: DATA_GUARD_REPORT_INCIDENT_FAILED });
        yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      }
    }

    if (allSuccessful) {
      yield put({ type: DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
    }

    yield put({ type: SET_DATA_GUARD_REPORT_INCIDENT_DETAILS, payload: results });
  } catch (err) {
    console.error("Error in createDataGuardJiraIncident saga:", err);
    yield put({ type: DATA_GUARD_REPORT_INCIDENT_FAILED });
    yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
  } finally {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
  }
}

function* updateAlertStatus(action) {
  yield put({ type: SET_POPUP_LOADER, payload: true });
  const { status, sysGuardData, loc: location, isCompliance } = action.payload;
  let options;
  let errorInfo;
  const handleServerError = (errorData) => {
    errorInfo = errorData;
  };
  try {
    options = {
      method: "PUT",
      url: `${UPDATE_ALERTS_STATUS_URL}/${action.payload.status}`,
      headers: getAxiosHeaders(true),
      data: action.payload.ids,
    };
    try {
      if (action.payload.ids.length !== 0) {
        const res = yield getService(options, handleServerError);
        if (res && res.status === 204) {
          yield put({ type: FETCH_POPUP_DATA });
          
          // Dispatch success action for snackbar
          yield put({
            type: UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
            payload: "Alert status updated successfully",
          });
          yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
          
          // Reload header data and details page table data after successful action
          const fromTimeStamp = yield select((state) => state.DataguardReducer.fromTimeStamp);
          const toTimeStamp = yield select((state) => state.DataguardReducer.toTimeStamp);
          const detailPageData = yield select((state) => state.DetailPageReducer);
          
          // Refresh header data with current date range
          if (fromTimeStamp && toTimeStamp) {
            yield put({ 
              type: GET_DATAGUARD_HEADER_DATA, 
              payload: { fromTimeStamp, toTimeStamp } 
            });
          }
          
          // Refresh detail page data if available
          if (detailPageData && detailPageData.lastPageType && detailPageData.lastApiEndpoint) {
            yield put({
              type: FETCH_DETAIL_PAGE_DATA_REQUEST,
              payload: {
                pageType: detailPageData.lastPageType,
                apiEndpoint: detailPageData.lastApiEndpoint,
                fromTimeStamp,
                toTimeStamp,
                page: detailPageData.page,
                rowsPerPage: detailPageData.rowsPerPage
              }
            });
          }

        } else {
          let errorMessage = "";
          // handling server errors ifor create alert
          if (errorInfo && errorInfo.errorMessage) {
            errorMessage = errorInfo.errorMessage;
          } else {
            errorMessage = "Update unsuccessful";
          }
          yield put({
            type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
            payload: errorMessage,
          });
          yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
        }
      }
    } catch (error) {
      console.log(error);
      // myStorage.setItem("access_token", "error");
      yield put({
        type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
        payload: "Error Fetching Data from API",
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      yield put({ type: SET_POPUP_LOADER, payload: false });
    }
  } catch (e) {
    yield put({ 
      type: UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
      payload: "Update failed due to unexpected error"
    });
    yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
    yield put({ type: SET_POPUP_LOADER, payload: false });
  }
}

function* alertActionDataGuard(action) {
  try {
    yield put({ type: 'DETAILS_PAGE_LOADER', payload: true });
    const { actionType, policyId } = action.payload;
    let options = {
      method: "PUT",
      url: alertActionAPI(actionType),
      headers: {
        ...getAxiosHeaders(true),
        "Content-Type": "text/plain",
      },
      data: policyId,
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({
        type: ALERT_ACTION_SUCCESS_DATAGUARD,
        payload: `Alerts marked as ${actionType.toLowerCase().replace('_', ' ')} successfully`,
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      
      // Reload the detail page data after successful action
      const fromTimeStamp = yield select((state) => state.DataguardReducer.fromTimeStamp);
      const toTimeStamp = yield select((state) => state.DataguardReducer.toTimeStamp);
      const detailPageData = yield select((state) => state.DetailPageReducer);
      
      if (detailPageData && detailPageData.lastPageType && detailPageData.lastApiEndpoint) {
        yield put({
          type: FETCH_DETAIL_PAGE_DATA_REQUEST,
          payload: {
            pageType: detailPageData.lastPageType,
            apiEndpoint: detailPageData.lastApiEndpoint,
            fromTimeStamp,
            toTimeStamp,
            page: detailPageData.page,
            rowsPerPage: detailPageData.rowsPerPage
          }
        });
      } else {
        // If no detail page data is available, just set success state
        yield put({ type: 'FETCH_DETAIL_PAGE_DATA_SUCCESS', payload: { data: detailPageData?.data || null } });
      }
    }
    else {
      yield put({
        type: ALERT_ACTION_FAILED_DATAGUARD,
        payload: `Failed to mark alerts as ${actionType.toLowerCase().replace('_', ' ')}`,
      });
      yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
      yield put({ type: 'FETCH_DETAIL_PAGE_DATA_FAILURE', payload: `Failed to mark alerts as ${actionType.toLowerCase().replace('_', ' ')}` });
    }
  } catch (error) {
    console.error("Error performing alert action:", error);
    yield put({
      type: ALERT_ACTION_FAILED_DATAGUARD,
      payload: "Failed to perform alert action",
    });
    yield put({ type: 'DETAILS_PAGE_LOADER', payload: false });
    yield put({ type: OPEN_DATA_GUARD_SNACKBAR, payload: true });
    yield put({ type: 'FETCH_DETAIL_PAGE_DATA_FAILURE', payload: "Failed to perform alert action" });
  }
}

function* DataGuardSaga() {
  yield takeEvery(GET_DATAGUARD_HEADER_DATA, fetchHeaderData);
  yield takeEvery(GET_DATAGUARD_HEATMAP_DATA, fetchHeatmapData);
  yield takeEvery(GET_DATAGUARD_ROLES_DATA, fetchRolesData);
  yield takeEvery(GET_DATAGUARD_BEHAVIOR_DATA, fetchBehaviorData);
  yield takeEvery(GET_LOCATION_SUMMARY, fetchLocationSummary);
  yield takeEvery(GET_KEY_DOC_OWNER_DATA, fetchKeyDocOwner);
  yield takeEvery(DATA_GUARD_NOTIFICATION_TOGGLE, dataGuardNotificationToggle);
  yield takeEvery(PUBLIC_ACCESS_REVOKE_USER, revokePublicAccessUser);
  yield takeEvery(SAVE_DATA_GUARD_COMMENT, saveDataGuardAlertComment);
  yield takeEvery(CREATE_DATA_GUARD_JIRA_INCIDENT, createDataGuardJiraIncident);
  yield takeEvery(UPDATE_ALERT_STATUS_REQUEST_DATAGUARD, updateAlertStatus);
  yield takeEvery(ALERT_ACTION_REQUEST_DATAGUARD, alertActionDataGuard);
}

export default DataGuardSaga;
